import { defineComponent as n, createBlock as a, openBlock as r, unref as l, mergeProps as c, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconLeaf",
  __name: "IconLeaf",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (r(), a(l(f), c(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M6.69 16.707a7.75 7.75 0 0 1 4.635-13.365L17.8 2.776a1.25 1.25 0 0 1 1.354 1.136l.567 6.475a7.75 7.75 0 0 1-11.813 7.258 58.72 58.72 0 0 0-1.137 2.716l-.158.397A.75.75 0 1 1 5.22 20.2l.157-.395c.361-.908.794-1.994 1.312-3.099m-.916-5.1a6.25 6.25 0 0 1 5.681-6.77l6.227-.545.544 6.226a6.25 6.25 0 0 1-9.655 5.77c.784-1.489 1.71-2.84 2.814-3.723a.75.75 0 1 0-.937-1.172c-1.257 1.006-2.25 2.44-3.047 3.903a6.223 6.223 0 0 1-1.627-3.689",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
